import { assets } from "@/lib/assets"

const moments = [
  {
    title: "BEFORE THE SHOW",
    subtitle: "演出之前",
    desc: "讓自己進入今晚的情緒。",
    image: assets.spray,
  },
  {
    title: "AFTER THE SHOW",
    subtitle: "散場之後",
    desc: "延續那份感動。",
    image: assets.afterShow,
  },
]

function Lifestyle() {
  return (
    <section data-nav="dark" className="bg-[#efe8dc] px-8 py-20 md:px-10 md:py-24">
      <div className="mx-auto max-w-5xl">
        <h2 className="font-display text-[32px] tracking-[0.22em] text-slate-700 md:text-[40px]">
          IN DAILY LIFE
        </h2>
        <p className="mt-3 text-[13px] tracking-[0.12em] text-slate-500">
          在不同的時刻，讓微光陪著你。
        </p>

        <div className="mt-12 grid gap-8 lg:grid-cols-[1.05fr_0.95fr] lg:items-stretch lg:gap-10">
          <div className="overflow-hidden bg-slate-200">
            <img src={assets.dailyLife} alt="江美琪日常時刻" className="h-full min-h-[420px] w-full object-cover lg:min-h-[640px]" />
          </div>
          <div className="flex flex-col justify-start gap-[0.5cm] lg:relative lg:block lg:h-full lg:min-h-[640px]">
            {moments.map((item, index) => (
              <article
                key={item.title}
                className={`grid grid-cols-[112px_1fr] items-center gap-5 md:grid-cols-[150px_1fr] ${index === 0 ? "lg:absolute lg:left-0 lg:right-0 lg:top-1/3 lg:-translate-y-1/2" : "lg:absolute lg:left-0 lg:right-0 lg:top-2/3 lg:-translate-y-1/2"}`}
              >
                <div className="aspect-square overflow-hidden bg-slate-200">
                  <img src={item.image} alt={item.subtitle} className="h-full w-full object-cover" />
                </div>
                <div>
                  <p className="font-display text-[14px] tracking-[0.16em] text-slate-700 md:text-[16px]">
                    {item.title}
                  </p>
                  <p className="mt-1 text-[12px] tracking-[0.16em] text-slate-500">{item.subtitle}</p>
                  <p className="mt-2 text-[13px] leading-7 text-slate-500">{item.desc}</p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}

export default Lifestyle
